'use client'
import type { FC } from 'react'
import { Box } from '@chakra-ui/react'
import tryggehandel from '#/src/images/tryggehandel.webp'
import { useAppConfigContext } from '#/src/appConfig'
import { GrandImage } from 'ui'
import { FooterStandard, type FooterStandardProps } from 'storefront-modules/layout/footer'

type IFooter = Pick<FooterStandardProps, 'footerItems' | 'logo' | 'socialMediaItems'>

const CustomFooter: FC<IFooter> = ({ logo, footerItems, socialMediaItems }) => {
  const appConfig = useAppConfigContext()

  return (
    <FooterStandard
      logo={logo}
      footerItems={footerItems}
      socialMediaItems={socialMediaItems}
      paymentProviderName={appConfig.paymentProviderConfig?.providerName}
      paymentMethodLogos={appConfig.paymentMethodLogos}
      maxColumns={appConfig.footerConfig?.maxColumns}
      socialMediasAfterAddon={
        <Box>
          <GrandImage alt="Tryggehandel" height={95} src={tryggehandel} width={95} />
        </Box>
      }
    />
  )
}

export default CustomFooter
